import React from 'react';
//import { Input } from 'antd';
import { InputForm } from 'styled';

function InputComponent(props) {
  return <InputForm {...props} />;
}

export default InputComponent;
